import { useEffect } from "react";
import { useGame } from "../state/store";

const TOAST_MS = 3500;

export function ToastHost() {
  const toast = useGame((s) => s.toast);
  const clearToast = useGame((s) => s.clearToast);
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => clearToast(toast.id), TOAST_MS);
    return () => clearTimeout(id);
  }, [toast, clearToast]);
  if (!toast) return null;
  return (
    <div
      className={`toast${toast.tone === "error" ? " toast-error" : ""}`}
      role={toast.tone === "error" ? "alert" : "status"}
      onClick={() => clearToast(toast.id)}
    >
      {toast.text}
    </div>
  );
}

export function ConnectionBanner() {
  const status = useGame((s) => s.status);
  if (status !== "reconnecting") return null;
  return (
    <div className="banner" role="status">
      Reconnecting… your seat is safe.
    </div>
  );
}
